import { render, staticRenderFns } from "./PassengerFlow.vue?vue&type=template&id=8cd1cd8a&"
import script from "./PassengerFlow.vue?vue&type=script&lang=js&"
export * from "./PassengerFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports